module.exports = new __parcel__URL__("Invite.20f05c87.svg").toString();